function Footer() {
    return (
    <footer className="py-8">

    </footer>
    )
}

export default Footer;